"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtrasCarouselWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var ExtrasCarousel_1 = require("../../../../components/annual/home/ExtrasCarousel");
var ExtrasCarouselWidget = /** @class */ (function (_super) {
    __extends(ExtrasCarouselWidget, _super);
    function ExtrasCarouselWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.editCoverLevelNavigate = function () {
            _this.props.engine.navigate("editCoverLevel", false);
        };
        return _this;
    }
    ExtrasCarouselWidget.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(ExtrasCarousel_1.ExtrasCarousel, __assign({ editCoverLevelNavigate: this.editCoverLevelNavigate }, this.props));
    };
    return ExtrasCarouselWidget;
}(plugin_journey_1.WidgetBase));
exports.ExtrasCarouselWidget = ExtrasCarouselWidget;
//# sourceMappingURL=ExtrasCarouselWidget.js.map